import(/* webpackMode: "eager" */ "/var/app/current/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/current/src/app/category/[slug]/components/categoryBanner/categoryBanner.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/current/src/app/category/[slug]/components/categoryList/categoryList.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/var/app/current/src/components/ui/label.tsx");
;
import(/* webpackMode: "eager" */ "/var/app/current/src/images/appleStore.png");
;
import(/* webpackMode: "eager" */ "/var/app/current/src/images/googlePlay.png");
;
import(/* webpackMode: "eager" */ "/var/app/current/src/images/logo.png");
;
import(/* webpackMode: "eager" */ "/var/app/current/src/images/logoWhite.png");
